// The antiforgery cookie is only set on the response that renders a form, while the matching token
// lives in the HTML. Any page reused without hitting the origin - a CDN cache, Safari's back/forward
// cache, a tab restored after iOS dropped the session cookie - posts a token with no cookie behind it.
// Re-syncing both against the origin keeps the pair valid however the HTML was obtained.
const tokenUrl = "/antiforgery/token";

const refreshTokens = () => {
  const inputs = document.querySelectorAll(
    "input[name='__RequestVerificationToken']"
  );

  if (inputs.length === 0) return;

  fetch(tokenUrl, { credentials: "same-origin", cache: "no-store" })
    .then((response) => (response.ok ? response.text() : ""))
    .then((token) => {
      if (token) inputs.forEach((input) => (input.value = token));
    })
    .catch(() => {});
};

refreshTokens();

// Restored from the back/forward cache: the page never hit the origin, so re-sync.
window.addEventListener("pageshow", (event) => {
  if (event.persisted) refreshTokens();
});
